import React from 'react';
import { connect } from 'dva';
import shallowEqual from 'shallowequal';
import _ from 'lodash';
import authService from '../../abs/services/auth/authService';
import ISearchOption, { ILabeledValue, ISearchOptGroup } from '../ABSSearch/SearchView/ISearchOption';
import ABSSearchView from '../ABSSearch/SearchView';
import ABSGlobalSearch from '../ABSSearch/GlobalSearch';
import { IABSSearchProps } from './interface';
import ABSMessage from '../ABSMessage';
import { defaultResult, validatorWithMsg } from '../../utils/Validator';
import { defaultSearchField, formatSearchOptions, 
  searchType, SEARCH_RESULT_COUNT, setLabelInValue, 
  setStringValue } from './utils';
import commonUtils from '../../utils/commonUtils';

export interface IABSSearchState {
  loading?: boolean;
  value?: any;
  searchOptions: ISearchOption[] | ISearchOptGroup[];
  result?: any;
}
export class ABSSearch extends React.Component<IABSSearchProps, IABSSearchState> {
  static defaultProps = {
    format: 'value'
  };

  deleteStatus: boolean = false;

  constructor(props: IABSSearchProps) {
    super(props);
    this.onSearch = commonUtils.debounce(this.onSearch, 500);
    const { defaultValue, mode } = props;
    if (!commonUtils.hasValue(props, 'value')) {
      if (mode) {
        this.state = {
          value: defaultValue || [],
          result: defaultResult,
          loading: false,
          searchOptions: [],
        };
      } else {
        this.state = {
          value: defaultValue,
            // !defaultValue && defaultValue !== 0 
            // ? undefined 
            // : defaultValue,
          result: defaultResult,
          loading: false,
          searchOptions: [],
        };
      }
    } else {
      this.state = {
        result: defaultResult,
        loading: false,
        searchOptions: [],
      };
    }
  }

  componentWillReceiveProps(nextProps: IABSSearchProps) {
    const { defaultValue, mode } = nextProps;
    if (!commonUtils.hasValue(nextProps, 'value')) {
      if (mode) {
        
        if (!shallowEqual(defaultValue, this.props.defaultValue)) {
          this.setState({
            value: defaultValue || [],
            result: defaultResult
          });
        }
      } else {
        if (!shallowEqual(defaultValue, this.props.defaultValue)) {
          this.setState({
            value: defaultValue,
              // !defaultValue && defaultValue !== 0 
              // ? undefined 
              // : defaultValue,
            result: defaultResult
          });
        }
      }
    } else {
      this.setState({
        result: defaultResult
      });
    }
  }

  onSearch = (searchValue: string) => {
    if (!searchValue) {
      this.setState({ searchOptions: [] });
      return;
    }

    const { mode, type = searchType.product, allowCustom, alwaysCustom } = this.props;
    this.setState({ searchOptions: [], loading: true });
    // 先判断是否为多选(mode)，在判断搜索类型(type)
    if (mode === 'multiple') {
      const { dispatch } = this.props;
      if ( type === searchType.expert) {
        // 专家+多选
        dispatch({
          type: 'account/getSearchUserList',
          payload: { name: searchValue }
        }).then(response => {
          const res = formatSearchOptions(response, searchType.expert, searchValue, allowCustom, alwaysCustom, `custom${Math.random()}`);
          this.setState({ searchOptions: res, loading: false });
        });
      } else if ( type === searchType.security) {
        // 证券+多选
        this.props.dispatch({
          type: 'global/searchSecurity',
          payload: {
            content: searchValue,
            count: SEARCH_RESULT_COUNT // 单个模糊查询取前10条，总结果可能超出10条
          }
        }).then(response => {
          const data = formatSearchOptions(response, type, searchValue, allowCustom, alwaysCustom, `custom${Math.random()}`, mode);
          this.setState({ searchOptions: data, loading: false });
        });
      }
      return;
    }

    const isLogin = authService.checkIsLogin();
    const isRegister = location.href.includes('/register');
    // 有权限的产品、证券、机构和专家的url，通过传参中的search_type区分
    let dispatchType = 'global/search';
    if (!isLogin && isRegister ) {
      // 未登录并且为注册页面时，无需权限可访问的url(注册时，机构的选取)
      dispatchType = 'global/searchOrganization'; 
    }
    this.props.dispatch({
        type: dispatchType,
        payload: {
          keyword: searchValue,
          search_type: type,
          count: SEARCH_RESULT_COUNT
        }
      })
      .then(response => {
        const data = formatSearchOptions(response, type, searchValue, allowCustom, alwaysCustom);
        this.setState({ searchOptions: data, loading: false });
      });
  };

  /**
   * 验证
   */
  validatorValue = () => {
    const { title, rules = [], required, value: propsValue, type } = this.props;
    const {title: newTitle} = defaultSearchField(type, title);
    if (!rules.length && !required) {
      return defaultResult;
    }
    let newRules = _.cloneDeep(rules);
    if (required) {
      newRules.push({ required, message: '请选择' + (newTitle || '内容') });
    }

    const { value } = this.state;
    const result = validatorWithMsg(propsValue || value, newRules);
    this.setState({ result });
    return result;
  };
  
  onChange = (searchValue: any, option: any) => {
    const { multipleMaxNum, title, type } = this.props;
    // 先判断多选的个数限制，超过错误提示
    if (
      Array.isArray(searchValue) &&
      multipleMaxNum &&
      searchValue.length > multipleMaxNum
    ) {
      const { title: newTitle } = defaultSearchField(type, title);
      ABSMessage.error(`最多选择${multipleMaxNum}个${newTitle}!`);
      return;
    }
    // antd-form组件，onChange和value值是不可变更的
    // 为区别新组件所需要的回调函数，请使用handleChange
    const {isForm, onChange} = this.props;
    if (isForm) {
      if (onChange) {
        onChange(searchValue);
        return;
      }
    } else {
      // 操作为取消选中时，onchange不再触发
      if (this.deleteStatus) {
        this.deleteStatus = false;
        return;
      }
      // 以下为handleChange回调中的传参处理
      let newOption = {
        value: '',
        text: '',
        desc: '',
        extra: ''
      };
      // 先将当前选中的value，赋值给新参数
      if (searchValue && Array.isArray(searchValue) && searchValue.length) {
        newOption.value = String(searchValue[searchValue.length - 1].key) || '';
      } else {
        newOption.value = String(searchValue.key) || '';
      }
      // 由于onchange返回的参数中，没有其他的属性，所以需要遍历searchOptions，通过value筛选出
      const { searchOptions } = this.state;
      const simpleOption = (options: any) => {
        const { desc: d = '', value: v, extra: e, text: t } = options;
        if (newOption.value === String(v)) {
          newOption.desc = d;
          newOption.extra = e;
          newOption.text = t;
          return true;
        }
        return false;
      };
      // isBreak为遍历到对应数据后就跳出整个循环
      if (Array.isArray(searchOptions) && searchOptions.length > 0) {
        let brk = false;
        for (const items of searchOptions) {
          const children = commonUtils.getValue(items, 'children');
          if (children && children.length >= 0) {
            // 存在多层级结构，需要增加一次遍历（证券+多选+label显示时）
            for (const item of children) { 
              const isBreak = simpleOption(item);
              if (isBreak) {
                brk = true;
                break;
              }
            }
            if (brk) {
              break;
            }
          } else {
            // 单层结构
            const isBreak = simpleOption(items);
            if (isBreak) {
              break;
            }
          }
        }
      }

      // 非受控组件时，更新数据并加验证
      const {value} = this.state;
      let newValue: any = newOption;
      if (!commonUtils.hasValue(this.props, 'value')) {
        // 多选时，结构重构为数组
        if (Array.isArray(value)) {
          newValue = value;
          newValue.push(newOption);
        }
        this.setState({ value: newValue }, () => {
          this.validatorValue();
        });
      }
  
      // 新组件的回调操作
      const { handleChange } = this.props;
      if (handleChange) {
        let changeValue: string | any[] = newOption.value;
        let changeOption: ISearchOption | ISearchOption[] = newOption;
        if (Array.isArray(value)) {
          // 多选时，结构重构为数组
          changeValue = setStringValue(value, 'key');
          changeOption = newValue;
        }
        handleChange(changeValue, changeOption);
      }
    }
  };

  // 取消选中时调用，参数为选中项的 value (或 key) 值，仅在 multiple 或 tags 模式下生效
  onDeselect = (searchValue: ILabeledValue) => {

    if (!this.props.isForm) {
      // 操作为取消选中时，为使onchange不再触发，deleteStatus为true
      this.deleteStatus = true;
      const {key = ''} = searchValue;
      const {value} = this.state;
      const newValue = _.cloneDeep(value);
      // 将删除的searchValue对象，从value中剔除，并更新数据
      for (let i = 0; i < newValue.length; i++) {
        const { value: val } = newValue[i];
        if (key === val) {
          newValue.splice(i, 1);
          break;
        }
      }
      this.setState({value: newValue}, () => {
        this.validatorValue();
        // 删除操作的回调
        const { onDeselect } = this.props;
        if (onDeselect) {
          onDeselect(searchValue);
        }
      });
    }
  }

  getValue = () => { // valueType?: 'text' | 'desc'
    const {value} = this.state;
    const {format} = this.props;
    if (format === 'all') {
      return value;
    }
    // 返回的结果，单选为string，多选为array
    return setStringValue(value, 'value');
  };

  reset = () => {
    const { defaultValue, mode } = this.props;
    let newValue;
    if (mode) {
      newValue = defaultValue || [];
    } else {
      newValue = defaultValue;
        // defaultValue === undefined || defaultValue === null ? '' : defaultValue;
    }
    this.setState({
      value: newValue,
      result: defaultResult,
      searchOptions: []
    });
  };

  resetResult = () => {
    this.setState({ result: defaultResult });
  }

  setValue = (value) => {
    this.setState({
      value,
      result: defaultResult
    });
  }

  render() {
    const { searchOptions, value, loading, result } = this.state;
    const {
      type,
      style,
      mode,
      title,
      placeholder,
      className,
      required,
      disabled,
      dropdownClassName,
      labelWidth,
      contentWidth,
      removeMarginBottom,
      removePaddingLeft,
      isGlobalSearch,
      size,
      onKeyDown,
      isSearch,
      defaultValue,
      value: propsValue,
      isForm,
      isFlex,
      optionLabelProp,
      noRenderTitle,
      optionInline,
      noResult
    } = this.props;
    const defalutField = defaultSearchField(type, title, placeholder, noRenderTitle);
    const fieldParam = {
      labelWidth, 
      contentWidth,
      removePaddingLeft, 
      removeMarginBottom, 
      ...defalutField
    };
    
    let newValue = commonUtils.hasValue(this.props, 'value') ? propsValue : value;
    // 转为select可显示的格式，antd-form情况除外
    newValue = setLabelInValue(newValue, isForm);
    
    if (isGlobalSearch) {
      return (
        <ABSGlobalSearch
          size={size} 
          placeholder={placeholder}
          className={className}
          onKeyDown={onKeyDown}
          isSearch={isSearch}
        />
      );
    }
    return (
      <ABSSearchView
        defaultValue={defaultValue}
        value={newValue}
        result={result}
        style={style}
        mode={mode}
        onSearch={this.onSearch}
        searchOptions={searchOptions}
        loading={loading}
        onChange={this.onChange}
        disabled={disabled}
        className={className}
        required={required}
        dropdownClassName={dropdownClassName}
        labelInValue={true}
        onDeselect={this.onDeselect}
        isFlex={isFlex}
        optionLabelProp={optionLabelProp}
        optionInline={optionInline}
        noResult={noResult}
        {...fieldParam}
      />
    );
  }
}

const mapStateToProps = ({ global }) => {
  return { ...global, noResult: global.noResultSecurities };
};
export { ILabeledValue };
export default connect(
  mapStateToProps,
  null,
  null,
  { withRef: true }
)(ABSSearch);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSSearch/index.tsx